var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('wx-open-launch-app',{attrs:{"id":"launch-btn","appid":_vm.appid,"extinfo":_vm.extinfo}},[_c('script',{attrs:{"type":"text/wxtag-template"}},[_vm._v(" <style>.btn { padding: 12px }</style> <button class=\"btn\">打开App</button> ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }